import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import catalog from "../seo/featureCatalog.json";

/* Bloc standard des guides : la totalité des fonctionnalités Casanéo, par famille, un seul prix tout compris. */
export function CasaneoInBrief() {
  return (
    <section className="mt-12 rounded-2xl border border-white/10 bg-white/[0.03] p-6 sm:p-8" data-testid="casaneo-in-brief">
      <p className="text-xs uppercase tracking-[0.2em] text-brass">Casanéo en bref</p>
      <h2 className="font-serif text-2xl sm:text-3xl text-white mt-2">Tout ce qu'une conciergerie fait à la main, dans un seul outil — tout compris</h2>
      <p className="mt-3 text-sm text-slate-300 max-w-3xl">Un abonnement dès 25 € HT par logement et par mois, sans module payant, sans supplément par fonctionnalité, sans commission sur vos réservations. Seule option : la tarification dynamique JustPrice. Essai gratuit 14 jours, sans carte bancaire.</p>
      <div className="mt-6 grid gap-x-8 gap-y-4 sm:grid-cols-2 lg:grid-cols-3">
        {catalog.categories.map((c) => (
          <div key={c.slug} data-testid={`in-brief-${c.slug}`}>
            <p className="text-sm font-semibold text-white flex items-start gap-1.5"><Check className="h-4 w-4 text-emerald-400 shrink-0 mt-0.5" /> {c.name}</p>
            <ul className="mt-1.5 space-y-1 text-xs text-slate-400 leading-snug">
              {c.items.slice(0, 3).map((it) => { const t = it.split(" : ")[0].split(" — ")[0]; return <li key={it}>{t.length > 90 ? t.slice(0, 88).replace(/[,(\s]+$/, "") + "…" : t}</li>; })}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-6 flex flex-wrap gap-3 text-sm">
        <Link to="/fonctionnalites" className="underline text-slate-200 hover:text-white" data-testid="in-brief-features">Voir la liste complète des fonctionnalités</Link>
        <Link to="/tarifs" className="underline text-slate-200 hover:text-white" data-testid="in-brief-pricing">Tarifs tout compris</Link>
        <Link to="/casaneo-vs-smoobu" className="underline text-slate-200 hover:text-white" data-testid="in-brief-compare">Comparatifs</Link>
      </div>
    </section>
  );
}
